import * as requests from "../coraWebComponents/utils/requests";
import fileSaver from "file-saver";
import CoraError from "../coraWebComponents/utils/coraError";
import Urls from "../constants/Urls";

const getFile = async (url) => {
  try {
    let response = null;
    response = await fetch(url, {
      headers: {
        Authorization: requests.getAuthorizationHeader(),
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
const downloadFile = async (url) => {
  try {
    let res = await getFile(`${window.config.url}${url}`);
    if (res.status === 200) {
      const blob = await res.blob();
      const reportName = requests.parseFilenameFromContentDisposition(
        res.headers.get("content-disposition")
      );
      fileSaver.saveAs(blob, reportName);
    } else {
      res = await res.json();
      if (res.Code === "401.000" && (await requests.refreshToken())) {
        return await downloadFile();
      }
      throw new CoraError(res);
    }
  } catch (error) {
    throw error;
  }
};

export const getUserManual = async () => {
  try {
    let response = await getFile(`${window.config.url}${Urls.GET_USER_MANUAL}`);
    if (response.status === 200) {
      return {
        blob: await response.blob(),
        fileName: requests.parseFilenameFromContentDisposition(
          response.headers.get("content-disposition")
        ),
      };
    } else {
      const res = await response.json();
      if (res.Code === "401.000" && (await requests.refreshToken())) {
        return await getUserManual();
      }

      throw new CoraError(res);
    }
  } catch (error) {
    throw error;
  }
};

export const getAdminManual = async () => {
  try {
    let response = await getFile(`${window.config.url}${Urls.GET_ADMIN_MANUAL}`);
    if (response.status === 200) {
      return {
        blob: await response.blob(),
        fileName: requests.parseFilenameFromContentDisposition(
          response.headers.get("content-disposition")
        ),
      };
    } else {
      const res = await response.json();
      if (res.Code === "401.000" && (await requests.refreshToken())) {
        return await getAdminManual();
      }

      throw new CoraError(res);
    }
  } catch (error) {
    throw error;
  }
};

export const getReportsNames = async () => {
  const url = Urls.GET_REPORTS_NAMES;
  try {
    let res = await requests.get(url);
    res.Data = res.Data.map((NAME) => ({ L_CHECK: false, NAME }));
    return res;
  } catch (error) {
    throw error;
  }
};
export const downloadReport = async (reportName, I_AG_ZIADOST, inPDF) => {
  try {
    const url = `${Urls.REPORTS}?reportName=${reportName}&ziadostId=${I_AG_ZIADOST}&inPDF=${inPDF}`;
    await downloadFile(url);
  } catch (error) {
    throw error;
  }
};
export const downloadPriloha = async (I_AG_ZIAD_BIN, fileName, l_vyjadrenie) => {
  try {
    const url = `${Urls.GET_PRILOHA}?id=${I_AG_ZIAD_BIN}&name=${fileName}&l_vyjadrenie=${l_vyjadrenie}`;
    await downloadFile(url);
  } catch (error) {
    throw error;
  }
};
export const getBlob = async (I_AG_ZIAD_BIN) => {
  try {
    const url = `${Urls.GET_PRILOHA}?id=${I_AG_ZIAD_BIN}&name=map.png&l_vyjadrenie=${false}`;
    return await requests.getBlob(url);
  } catch (error) {
    throw error;
  }
};
export const uploadPrilohaZiadost = async (I_AG_ZIADOST, FILE_NAME, file) => {
  try {
    let res = await requests.postWithFile(
      Urls.UPLOAD_PRILOHA_ZIADOST,
      { I_AG_ZIADOST, FILE_NAME },
      file
    );
    return res;
  } catch (error) {
    throw error;
  }
};
export const uploadPrilohaVyjadrenie = async (
  I_AG_VYJADRENIE,
  FILE_NAME,
  file
) => {
  try {
    let res = await requests.postWithFile(
      Urls.UPLOAD_PRILOHA_VYJADRENIE,
      { I_AG_VYJADRENIE, FILE_NAME },
      file
    );
    return res;
  } catch (error) {
    throw error;
  }
};
export const uploadReport = async (
  reportName,
  I_AG_ZIADOST,
  I_AG_VYJADRENIE
) => {
  try {
    const url = `${Urls.UPLOAD_REPORT}?reportName=${reportName}&ziadostId=${I_AG_ZIADOST}&vyjadrenieId=${I_AG_VYJADRENIE}`;
    await requests.get(url);
  } catch (error) {
    throw error;
  }
};


